import React from 'react';
    import { motion } from 'framer-motion';

    const WhatThisIs = () => {
      const externalLink = "https://members.sellersanonymous.org/";

      return (
        <section id="about" className="py-20 bg-white">
          <div className="container">
            <div className="max-w-4xl mx-auto">
              <motion.div 
                initial={{ opacity: 0, y: 30 }} 
                whileInView={{ opacity: 1, y: 0 }} 
                viewport={{ once: true }} 
                transition={{ duration: 0.6 }} 
              >
                <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-8 text-center">
                  What is Sellers Anonymous?
                </h2>
                <div className="space-y-8 text-lg text-slate-600 leading-relaxed">
                  <p className="text-center text-xl font-medium text-slate-700">
                    Our mantra is simple: <span className="text-cyan-600 font-semibold">"Buyers First, the sale second."</span>
                  </p>
                  <p>
                    We believe that when you prioritise buyers' interests, act with integrity, and help them make good decisions, you are far more effective and feel good doing it.
                  </p>
                  <p>
                    We are a peer community of highly principled, buyer-centric sellers that gathers regularly to share real stories, dilemmas, and practical strategies—without scripts, bravado, or judgement.
                  </p>
                  <p>
                    We maintain independence from any specific individuals, programs, methodologies, or sales approaches, refraining from endorsing or opposing any particular framework.
                  </p>
                </div>

                <div className="mt-12 bg-slate-50 rounded-2xl p-8">
                  <h3 className="text-xl font-semibold text-slate-800 mb-6">In our meetings, we:</h3>
                  <ul className="space-y-4">
                    {[
                      'Talk honestly about deals that don\'t sit right',
                      'Explore ways to be buyer-centric, not buyer-manipulative',
                      'Use the principles of The Seller Code to navigate real situations',
                      'Leave with practical next steps to achieve exceptional sales results with a lighter conscience'
                    ].map((item, index) => (
                      <motion.li 
                        key={index} 
                        initial={{ opacity: 0, x: -20 }} 
                        whileInView={{ opacity: 1, x: 0 }} 
                        viewport={{ once: true }} 
                        transition={{ delay: index * 0.1 }} 
                        className="flex items-start space-x-3"
                      >
                        <div className="w-6 h-6 bg-cyan-100 rounded-full flex items-center justify-center mt-0.5 flex-shrink-0">
                          <div className="w-2 h-2 bg-cyan-600 rounded-full"></div>
                        </div>
                        <span className="text-slate-600">{item}</span>
                      </motion.li>
                    ))}
                  </ul>
                </div>

                <div className="text-center mt-12">
                  <p className="text-lg text-slate-600 mb-6">Ready to sit in on a session?</p>
                  <a 
                    href={externalLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block bg-cyan-600 hover:bg-cyan-700 text-white px-8 py-3 rounded-lg font-semibold transition-all duration-200 hover:shadow-lg hover:scale-105"
                  >
                    Join a Meeting
                  </a>
                </div>
              </motion.div>
            </div>
          </div>
        </section>
      );
    };

    export default WhatThisIs;